import i18n from '@/i18n'

const datePickerLang = () => {
  return {
    formatLocale: {
      weekdaysMin: [
        i18n.t('global.days.sun'),
        i18n.t('global.days.mon'),
        i18n.t('global.days.tue'),
        i18n.t('global.days.wed'),
        i18n.t('global.days.thu'),
        i18n.t('global.days.fri'),
        i18n.t('global.days.sat'),
      ],
      monthsShort: [
        i18n.t('global.months.jan'),
        i18n.t('global.months.feb'),
        i18n.t('global.months.mar'),
        i18n.t('global.months.apr'),
        i18n.t('global.months.may'),
        i18n.t('global.months.jun'),
        i18n.t('global.months.jul'),
        i18n.t('global.months.aug'),
        i18n.t('global.months.sep'),
        i18n.t('global.months.oct'),
        i18n.t('global.months.nov'),
        i18n.t('global.months.dec'),
      ],
    },
  }
}

export default datePickerLang
